export default __webpack_public_path__ + "static/main_logo-d0b20b258e59861acb20684b85acdefd.png";